import React, { useState, useEffect } from "react";
import styles from "./Skeleton.module.css";

export default function Skeleton() {
  const [cardCount, setCardCount] = useState(6);
  const categoryCount = 5; // Ցույց տանք 5 բաժնի կոճակ

  useEffect(() => {
    const updateCardCount = () => {
      if (window.innerWidth <= 600) {
        setCardCount(4); // Բջջայինի դեպքում ցույց տալ 4 քարտ
      } else if (window.innerWidth <= 1024) {
        setCardCount(6); // Պլանշետի դեպքում ցույց տալ 6 քարտ
      } else {
        setCardCount(9); // Մեծ (Desktop) էկրանների դեպքում ցույց տալ 9 քարտ
      }
    };

    // Կանչում ենք ֆունկցիան սկզբում՝ ճիշտ քանակը որոշելու համար
    updateCardCount();

    // Հետևում ենք էկրանի չափսերի փոփոխությանը
    window.addEventListener("resize", updateCardCount);
    return () => window.removeEventListener("resize", updateCardCount);
  }, []);

  return (
    <div className={styles.skeletonLoader} style={{ overflowX: "hidden" }}>
      {/* 1. Nav (Header) Skeleton */}
      <div className={styles.navSkeleton}>
        <div className={`${styles.iconPlaceholder} ${styles.shimmer}`}></div>
        <div className={`${styles.logoPlaceholder} ${styles.shimmer}`}></div>
        <div className={`${styles.iconPlaceholder} ${styles.shimmer}`}></div>
      </div>

      {/* 2. Categories Bar Skeleton */}
      <div 
        className={styles.categoriesSkeleton} 
        style={{ overflowX: "hidden", scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {Array.from({ length: categoryCount }).map((_, index) => (
          <div key={`cat-${index}`} className={`${styles.categoryTabPlaceholder} ${styles.shimmer}`}></div>
        ))}
      </div>

      {/* 3. Category Title Skeleton */}
      <div className={`${styles.titleSkeleton} ${styles.shimmer}`}></div>

      {/* 4. Menu Items Grid Skeleton */}
      <div className={styles.gridSkeleton}>
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={`card-${index}`} className={styles.cardSkeleton}>
            <div className={`${styles.cardImagePlaceholder} ${styles.shimmer}`}></div>
            
            {/* Տեքստի և գնի համադրությունը */}
            <div className={styles.cardInfoOverlay}>
              <div className={`${styles.cardTextLarge} ${styles.shimmer}`}></div>
              <div className={`${styles.cardTextSmall} ${styles.shimmer}`}></div>
              <div className={`${styles.pricePillPlaceholder} ${styles.shimmer}`}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}